import PorkRoll from './PorkRoll';
import '../../styles/game.scss';
import useEvent from '../../hooks/useEvent';
import { useState, useEffect, useRef } from 'react';
import PlatformModel from '../../models/PlatformModel';
import SpikeModel from '../../models/SpikeModel';
import Platform from './Platform';
import Spike from './Spike';
import Orb from './Orb';
import SceneProperties from '../../data/SceneProperties';
import Normalise from "../../util/Normalise";
import CrusherModel from '../../models/CrusherModel';
import PlatformType from '../../models/PlatformTypeModel';
import Portal from './Portal';
import PortalModel from '../../models/PortalModel';
import Batton from './Batton';
import BulletModel from '../../models/BulletModel';
import Gun from './Gun';
import OrbModel from '../../models/OrbModel';
import ActionTypeModel from '../../models/ActionTypeModel';
import ActionModel from '../../models/ActionModel';
import Engine from '../../engine/Engine';
import Audio from './Audio';
import { useNavigate } from "react-router-dom";
import GetOrbRouteByIndex from '../../data/OrbRoutes';
import PocketTypes from '../../models/PocketTypes';
import Pocket from './Pocket';
import DefaultPocket from './DefaultPocket';

const INIT_ROLL_STATE: PorkrollModel = {
  left: 0,
  rotate: 0,
  bottom: 0,
  direction: 1
};

/**DEBUG COMPONENTS */
// function initialiseBattonTrackers(){
//   const TRACK_BAT_DATA = [
//     new PlatformModel(0, 0, 1, 1),
//     new PlatformModel(15, 0, 1, 1),
//     new PlatformModel(0, 15, 1, 1),
//     new PlatformModel(15, 15, 1, 1),
//   ]
//   SceneProperties.battonTrackers = TRACK_BAT_DATA;
// }

function initGame(fact: number) {
  SceneProperties.totalWidthFact = fact;
  initialisePseudoconstants();
  initialisePlatforms();
  initialiseSpikes();
  initialiseCrushers();
  initialisePortals();
  initialiseBattons();
  initialiseBullets();
  initialiseGun();
  initialiseOrbs();
  // initialiseBattonTrackers();   //debug
}

function initialiseOrbs() {
  const ORBS = [
    new OrbModel(33, 4, 4.5),
    new OrbModel(33, 61.6, 4.5),
    new OrbModel(3, 91.5, 4.5),
    new OrbModel(49, 55.7, 4.5),
    new OrbModel(66.5, 4, 4.5)
  ]
  SceneProperties.orbs = ORBS;
}

function initialiseGun() {
  const GUN = [new PlatformModel(84.78, 0, 5, 3.5)];
  SceneProperties.guns = GUN;
}

function initialiseBullets() {
  const BULLET_DATA = [
    new BulletModel(-1 * SceneProperties.bulletWidth),
    new BulletModel(-1 * SceneProperties.bulletWidth)
  ]

  SceneProperties.bullets = BULLET_DATA;
}

function initialiseBattons() {
  const INIT_BATTON: BattonModel = {
    height: 16 / 100 * window.innerHeight,
    width: 9 / 100 * document.body.clientWidth * SceneProperties.totalWidthFact,
    bottom: 61.5 / 100 * window.innerHeight,
    rotate: -20,
    left: SceneProperties.platforms[5].width,
  }

  SceneProperties.battons = [INIT_BATTON];
}

function initialisePseudoconstants() {
  SceneProperties.acceleration = Normalise(15, true);
  SceneProperties.dragLimit = Normalise(3, true);
  SceneProperties.topSpeed = Normalise(70, true);
  SceneProperties.playerSize = window.innerHeight * 0.1;
  SceneProperties.playerGlow = null;

  SceneProperties.gravity = Normalise(55, false);
  SceneProperties.jumpPower = Normalise(140, false);//150
  SceneProperties.bleadTweak = Normalise(23, false);
  SceneProperties.orbAmplitude = Normalise(7, false);

  //bullets
  SceneProperties.bulletWidth = 3.5 / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
  SceneProperties.bulletAmplitude = Normalise(840, true);
}

function initialiseSpikes() {
  const SPIKE_DATA = [
    new SpikeModel(51, 70.7, true),
    new SpikeModel(51, 70.7, true),
    new SpikeModel(43.8, 40.35),
    new SpikeModel(43.8, 42.35),
    new SpikeModel(43.8, 44.35),
    new SpikeModel(43.8, 46.35),
    new SpikeModel(43.8, 48.35),
    new SpikeModel(43.8, 50.35),
  ];

  SceneProperties.spikes = SPIKE_DATA;
}

function initialisePortals() {
  const PORTAL_DATA = [
    new PortalModel(48, -0.2, false),
    new PortalModel(83.3, 28, true),
  ];

  SceneProperties.portals = PORTAL_DATA;
}

function initialiseCrushers() {
  const CRUSHER_DATA = [
    new CrusherModel(0, 50, 30, 2.5),
    new CrusherModel(0, 60, 30, 2.5, 1),
    new CrusherModel(0, 70, 30, 2.5)
  ]

  SceneProperties.crushers = CRUSHER_DATA;
}

function initialisePlatforms() {
  const PLATFORM_DATA = [
    //MOVING PLATFORMS
    new PlatformModel(15, 88.1, 3, 20, new ActionModel(ActionTypeModel.RIGHT, 150)),
    new PlatformModel(33, 71.8, 3, 12, new ActionModel(ActionTypeModel.LEFT, 150, 1)),
    new PlatformModel(51, 88.1, 3, 20, new ActionModel(ActionTypeModel.RIGHT, 150)),
    new PlatformModel(69, 68, 3, 6, new ActionModel(ActionTypeModel.RIGHT, 150)),

    //STATIC PLATFORMS
    new PlatformModel(13, 25, 3, 12),
    new PlatformModel(44.9, 0, 3, 60.2),    //yeet [5]
    new PlatformModel(29.1, 0, 3, 17.9),
    new PlatformModel(29.1, 48.9, 3, 24.3),
    new PlatformModel(29.2, 69.7, 23.3, 4, null, false),   //vert [8]


    new PlatformModel(62.5, 0, 3, 15.5),
    new PlatformModel(80.2, 12, 3, 28.4, null, true, true),
    new PlatformModel(62.5, 12, 19.7, 4, null, false),     //vert
    new PlatformModel(80.2, 36.9, 13.5, 4, null, false),   //vert

  ]

  //modify for operning
  PLATFORM_DATA[5].width = PLATFORM_DATA[8].left - (1.5 * SceneProperties.playerSize);

  for (let i = 0; i < PLATFORM_DATA.length; i++) {
    if (PLATFORM_DATA[i].type === PlatformType.MOVING) {
      switch (PLATFORM_DATA[i].action.type) {
        case ActionTypeModel.LEFT:
          //altering width
          PLATFORM_DATA[i].action.init = PLATFORM_DATA[i].width;
          break;
        case ActionTypeModel.RIGHT:
          //altering left
          PLATFORM_DATA[i].action.init = PLATFORM_DATA[i].left + PLATFORM_DATA[i].width;
          break;
        default:
          console.log("unsupported action type")
          break;
      }
    }
  }

  SceneProperties.platforms = PLATFORM_DATA;
}

function getRollState() {
  var state = INIT_ROLL_STATE;

  if (SceneProperties.checkPoint == null) return state;

  state.bottom = SceneProperties.checkPoint.bottom;
  state.left = SceneProperties.checkPoint.left;

  return state;
}

function Scene(props: any) {
  const [engine, setEngine] = useState<Engine | null>(null);
  const [porkRoll, setPorkRoll] = useState<PorkrollModel>(getRollState());
  const [platforms, setPlatforms] = useState<PlatformModel[]>([]);
  const [pocket, setPocket] = useState("");
  const engineRef = useRef<number>();
  const navigate = useNavigate();



  const handleKeyPress = (e: KeyboardEvent) => {
    if (engine == null) return;

    let key = e.key;

    switch (key) {
      case 'ArrowRight':
        engine.MoveRight();
        break;
      case 'ArrowLeft':
        engine.MoveLeft();
        break;
      case 'ArrowUp':
      case ' ':
        engine.Jump();
        break;
      case 'r':
        engine.ResetGame();
        break;
      case 'x':
        engine.DoSpecial();
        break;
      default:
        break;
    }
  }

  const handleKeyUp = (e: KeyboardEvent) => {
    if (engine == null) return;

    let key = e.key;

    switch (key) {
      case 'ArrowRight':
        engine.ResetRight();
        break;
      case 'ArrowLeft':
        engine.ResetLeft();
        break;
      case 'ArrowUp':
      case ' ':
        engine.ResetJump();
        break;
      default:
        break;
    }
  }

  const handleResize = () => {
    initGame(props.fact);

    if (engine == null) return;

    engine.ResetGame();
  }

  useEvent('keydown', handleKeyPress);
  useEvent('keyup', handleKeyUp);
  useEvent('resize', handleResize);

  useEffect(() => {

    initGame(props.fact);

    const handleNavigation = (ind: number) => {
      let orbRoute = GetOrbRouteByIndex(ind);

      if (orbRoute !== null) {
        if (orbRoute.route === "/") {
          return;
        }
        navigate(orbRoute.route);
      } else {
        console.log("Route not defined");
      }
    }

    setEngine(new Engine(
      (ref: any) => { engineRef.current = ref; },
      (porkRoll: PorkrollModel) => setPorkRoll(porkRoll),
      (platforms: PlatformModel[]) => setPlatforms(platforms),
      (index: number) => handleNavigation(index),
      (pocket: string) => { setPocket(pocket) },
    ));

    return () => {
      if (engineRef.current !== undefined) {
        window.cancelAnimationFrame(engineRef.current);
      }
    };
  }, [navigate, props.fact]);

  const getSpikes = (): SpikeModel[] => {
    return SceneProperties.spikes ? SceneProperties.spikes : [];
  }

  const getCrushers = (): CrusherModel[] => {
    return SceneProperties.crushers ? SceneProperties.crushers : [];
  }

  const getPortals = (): PortalModel[] => {
    return SceneProperties.portals ? SceneProperties.portals : [];
  }

  const getBattons = () => {
    return SceneProperties.battons ? SceneProperties.battons : [];
  }

  const getBullets = () => {
    return SceneProperties.bullets ? SceneProperties.bullets : [];
  }

  const getGuns = () => {
    return SceneProperties.guns ? SceneProperties.guns : [];
  }

  const getOrbs = (): OrbModel[] => {
    return SceneProperties.orbs ? SceneProperties.orbs : [];
  }

  // const getBattonTrackers = () => {
  //   return SceneProperties.battonTrackers ? SceneProperties.battonTrackers : [];
  // }

  let el;
  let arr;

  if (pocket !== "") {
    switch (pocket) {
      case PocketTypes.RESUME:
        arr = ["Experience", "Education", "Volunteering", "Academia", "Leadership", "Interests"];
        el = <>
          <Pocket section="Résumé" description="Take a squizz at my CV or come get to know me better!" secondary={arr} show />
        </>
        break;
      case PocketTypes.GAME:
        arr = ["React.js", "Typescript", "Sass", "Adobe Fresco", "Figma"];
        el = <>
          <Pocket section="Porkroll" description="A 2D platformer (nicknamed 'Porkroll') built in React.js which serves as an interactive menu for my personal website!" secondary={arr} />
        </>
        break;
      case PocketTypes.CONTACT:
        arr = ["Mobile Number", "Email Contact", "Social Media"];
        el = <>
          <Pocket section="Contact Me" description="Get in touch and let's chat!" secondary={arr} show/>
        </>
        break;
      case PocketTypes.FAITH:
        arr = ["An Invitation", "The Gospel", "Apologetics"];
        el = <>
          <Pocket section="Faith" description="Jesus is the cornerstone of all that I do! Whether you're an atheist, agnostic, monotheist, or polytheist, feel free to take a peek!" secondary={arr} show/>
        </>
        break;
      case PocketTypes.SHOWCASE:
        arr = ["Mobile Apps", "Websites", "Web Apps", "Game Dev", "AI/ML"];
        el = <>
          <Pocket section="Projects" description="Take a look at the projects I've been working on!" secondary={arr} show />
        </>
        break;
      case PocketTypes.TELEPORT:
        el = <>
          <DefaultPocket teleport={true}/>
        </>
        break;
      default:
        console.log("Err: unsupported pocket type")
    }
  } else {
    el = <>
      <DefaultPocket teleport={false} />
    </>
  }

  return (
    <>
      <Audio />
      <div className='sceneCover' style={{
        width: `${(1 - (SceneProperties.totalWidthFact + 0.25)) * 100}vw`
      }}>

      </div>
      <div className="scene" style={{
        width: `${SceneProperties.totalWidthFact * 100}vw`,
        marginLeft: `${(1 - (SceneProperties.totalWidthFact + 0.25)) * 100}vw`
      }}>
        <PorkRoll left={porkRoll.left} rotate={porkRoll.rotate} bottom={porkRoll.bottom} direction={porkRoll.direction} />
        {
          platforms.map((platform: PlatformModel, index) => {
            return <Platform key={index} type={platform.type} left={platform.left} bottom={platform.bottom} width={platform.width} height={platform.height} isHoriz={platform.isHoriz} cover={platform.coverup} />
          })
        }
        {
          getSpikes().map((spike: SpikeModel, index) => {
            return <Spike key={index} left={spike.left} bottom={spike.bottom} size={spike.size} />
          })
        }
        {
          getCrushers().map((crusher, index) => {
            return <Platform key={index} left={crusher.left} bottom={crusher.bottom} width={crusher.width} height={crusher.height} type={PlatformType.CRUSHER} isHoriz={false} cover={false} />
          })
        }
        {
          getPortals().map((portal, index) => {
            return <Portal key={index} left={portal.left} bottom={portal.bottom} width={portal.width} height={portal.height} right={portal.toRight} />
          })
        }
        {
          getBattons().map((batton, index) => {
            return <Batton key={index} left={batton.left} width={batton.width} height={batton.height} bottom={batton.bottom} rotate={batton.rotate} />
          })
        }
        {
          getBullets().map((bullet, index) => {
            return <Platform key={index} left={bullet.left} bottom={bullet.bottom} width={bullet.width} height={bullet.height} type={PlatformType.BULLET} isHoriz={true} cover={false} />
          })
        }
        {
          getGuns().map((gun, index) => {
            return <Gun key={index} left={gun.left} bottom={gun.bottom} width={gun.width} height={gun.height} />
          })
        }
        {
          getOrbs().map((orb: OrbModel, index) => {
            return <Orb key={index} left={orb.left} bottom={orb.bottom} size={orb.size} />
          })
        }

      </div>
      {el}
    </>
  );
}

export default Scene;
